// Wordmark ODPTech para a sidebar (fundo escuro no tema ODPTech).
// "od" laranja · "p" teal-petróleo sobre quadrado teal · "tech" branco.
const ORANGE = '#e2571e';
const TEAL = '#17a2b8';
const PETROL = '#0d5457';

export const LogoFull = () => (
  <span
    role="img"
    aria-label="odptech"
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      fontFamily: 'Inter, sans-serif',
      fontWeight: 800,
      fontSize: 26,
      lineHeight: 1,
      letterSpacing: '-0.04em',
      userSelect: 'none',
    }}
  >
    <span style={{ color: ORANGE }}>od</span>
    <span style={{ position: 'relative', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
      <span
        aria-hidden
        style={{ position: 'absolute', top: -4, bottom: -4, left: -2, right: -2, background: TEAL, borderRadius: 3 }}
      />
      <span style={{ position: 'relative', color: PETROL }}>p</span>
    </span>
    <span style={{ color: '#ffffff' }}>tech</span>
  </span>
);
